import { Routes } from '@angular/router';
import { authorizedGuard } from 'core/guards';
import { DashboardComponent } from 'dashboard/dashboard.component';
import { HallOfShameComponent } from 'hall-of-shame/hall-of-shame.component';
import { NotificationsComponent } from 'notifications/notifications.component';
import { PlayersComponent } from 'players/players.component';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'account',
        loadChildren: () => import('./app/account/routes').then((m) => m.routes),
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.DASHBOARD',
        },
    },
    {
        path: 'players',
        component: PlayersComponent,
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.PLAYERS',
        },
    },
    {
        path: 'statistics',
        loadChildren: () => import('./app/statistics/routes').then((m) => m.routes),
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.STATISTICS',
        },
    },
    {
        path: 'hall-of-shame',
        component: HallOfShameComponent,
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.HALL_OF_SHAME',
        },
    },
    {
        path: 'settings',
        loadChildren: () => import('./app/settings/routes').then((m) => m.routes),
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.SETTINGS',
        },
    },
    {
        path: 'achievements',
        loadChildren: () => import('./app/achievements/routes').then((m) => m.routes),
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.ACHIEVEMENTS',
        },
    },
    {
        path: 'widgets',
        loadChildren: () => import('./app/widgets/routes').then((m) => m.routes),
        canActivate: [authorizedGuard],
    },
    {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [authorizedGuard],
        data: {
            pageTitle: 'PAGE_TITLE.NOTIFICATIONS',
        },
    },
    {
        path: 'vanoce-2025',
        loadComponent: () =>
            import('./app/christmas-tournament/christmas-tournament.component').then((m) => m.ChristmasTournamentComponent),
        canActivate: [authorizedGuard],
    },
    {
        path: '**',
        redirectTo: '/dashboard',
    },
];
